import PropTypes from 'prop-types'

const SignalBars = ({ width = 14, height = 14, color = 'white', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <rect x="1" y="15" width="4" height="9" rx="1" />
    <rect x="7" y="10" width="4" height="14" rx="1" />
    <rect x="13" y="5" width="4" height="19" rx="1" />
    <rect x="19" y="1" width="4" height="23" rx="1" />
  </svg>
)

SignalBars.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}

export default SignalBars
